<template v-if="loading">
  <tr class="v-datatable__progress">
    <th
      :colspan="itemsLength"
      class="column"
    >
      <v-progress-linear
        indeterminate
        color="primary"
        height="2"
        value="1"
      />
    </th>
  </tr>
</template>
<script>
export default {
  props: ["itemsLength"],
};
</script>

